class Source {
  constructor() {
    this.embeddable = true
    this._tempCurrent = "0"
    this.inputs = {
      MAIN: "0",
      VOD: "0",
      HLS: "0",
      MULTICAST: "0",
      RF: "0",
      HDMI1: "hdmi1",
      HDMI2: "hdmi2",
      HDMI3: "hdmi3"
    }
  }
  _init = async () => {
    const current = await this.get()

    if (current !== this.inputs.MAIN) await this.set(this.inputs.MAIN)

    return true
  }
  get = async () => {
    return this._tempCurrent
  }
  set = async source => {
    this._tempCurrent = source.toString()
    _$.handler.emit("source", this._tempCurrent)
    return true
  }
}

export default Source
